import useEarningTypes from './data/useEarningTypes'
import useCampaignTypes from './data/useCampaignTypes'
import CampaignProducts from './data/CampaignProducts'
import CampaignProductsGiveAway from './data/CampaignProductsGiveAway'
import { useVIP } from '../hook'
import SelectProducts from './components/SelectProducts'
import SelectGiftProducts from './components/SelectGiftProduct'
import { useIntl } from 'react-intl'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

function CampaignEdit({
  Field,
  Form,
  setFieldValue,
  values,
  touched,
  errors,
  section,
  setSection,
  disabled,
}: {
  Field: any
  Form: any
  setFieldValue: any
  values: any
  touched: any
  errors: any
  section: any
  setSection: any
  disabled: boolean
}) {
  const intl = useIntl()

  const { sectionRender } = useEarningTypes()
  const { sectionRender: sectionRenderCampaign } = useCampaignTypes()

  const { vipCampaignProductListAll, vipCampaignProductListAllSet, selectedGiveAwayProductSet } =
    useVIP()

  return (
    <>
      {section === 1 && (
        <div className='p-5'>
          {/* {disabled && (
            <div className='alert-light-danger' role='alert'>
              {intl.formatMessage({ id: 'CAMPAIGN.LIVE' })}
            </div>
          )} */}
          <Form className='form d-flex flex-column flex-lg-row fv-plugins-bootstrap5 fv-plugins-framework w-100'>
            <div className='row  mt-10 w-100'>
              <div className='col-md-12'>
                <div className='card'>
                  <div className='card-header'>
                    <div className='card-title d-flex flex-column'>
                      <div className='d-flex align-items-center position-relative my-1 fs-2 fw-bold'>
                        {intl.formatMessage({ id: 'CAMPAIGN.TITLE' })}
                      </div>
                    </div>
                  </div>
                  <div className={`card-body ${disabled ? 'card-disabled' : ''}`}>
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='input-group input-group-solid w-100'>
                          <Field
                            type='text'
                            name='name'
                            id='name'
                            placeholder='e.g. %5 off on all products'
                            className='form-control form-control-sm form-control-solid'
                            maxLength={51}
                          />
                        </div>

                        {errors.name && touched.name && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{errors.name}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className='card mt-10'>
                  <div className='card-header'>
                    <div className='card-title d-flex flex-column'>
                      <div className='d-flex align-items-center position-relative my-1 fs-2 fw-bold'>
                        {intl.formatMessage({ id: 'CAMPAIGN.TYPE' })}
                      </div>
                    </div>
                  </div>
                  <div className={`card-body ${disabled ? 'card-disabled' : ''}`}>
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='form-group mb-5 w-50'>
                          <div className='d-flex align-items-center gap-3 mt-5'>
                            <Field
                              type='radio'
                              name='promoCluster'
                              id='promoCluster'
                              className='form-check-input'
                              value='2'
                              onChange={() => {
                                setFieldValue('promoGroup', '11')
                                setFieldValue('promoCluster', '2')
                                setFieldValue('campaignType', '1')
                                setFieldValue('priceCluster', [])
                                setFieldValue('amountToBeSpent', '0')
                                setFieldValue('pointsToBeEarned', '0')
                                selectedGiveAwayProductSet([])
                              }}
                            />
                            <div className='fs-6'>
                              {/* {intl.formatMessage({ id: 'CAMPAIGN.TYPE.POINTS' })} */}
                              {intl.formatMessage({ id: 'CAMPAIGN.POINT.FIXED' })}{' '}
                              <span className='position-relative'>
                                <OverlayTrigger
                                  trigger='hover'
                                  placement='top'
                                  overlay={<Tooltip>{intl.formatMessage({ id: 'CAMPAIGN.POINT.FIXED_TOOLTIP' })}</Tooltip>}
                                >
                                  <i className='bi bi-info-circle text-primary ms-1'></i>
                                </OverlayTrigger>
                              </span>
                            </div>
                          </div>
                          <div className='d-flex align-items-center gap-3 mt-5'>
                            <Field
                              type='radio'
                              name='promoCluster'
                              id='promoCluster'
                              className='form-check-input'
                              value='1'
                              onChange={() => {
                                setFieldValue('promoGroup', '1')
                                setFieldValue('promoCluster', '1')
                                setFieldValue('campaignType', '2')
                                setFieldValue('priceCluster', [])
                                setFieldValue('amountToBeSpent', '')
                                setFieldValue('pointsToBeEarned', '')
                              }}
                            />
                            <div className='fs-6'>
                              {/* {intl.formatMessage({ id: 'CAMPAIGN.TYPE.DISCOUNT' })} */}
                              {intl.formatMessage({ id: 'DISCOUNT.AMOUNT_OFF_PERCENT_OFF' })}{' '}
                              <span className='position-relative'>
                                <OverlayTrigger
                                  trigger='hover'
                                  placement='top'
                                  overlay={<Tooltip>{intl.formatMessage({ id: 'DISCOUNT.AMOUNT_OFF_PERCENT_OFF_TOOLTIP' })}</Tooltip>}
                                >
                                  <i className='bi bi-info-circle text-primary ms-1'></i>
                                </OverlayTrigger>
                              </span>
                            </div>
                          </div>
                          {errors.campaignType && touched.campaignType && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{errors.campaignType}</div>
                            </div>
                          )}
                        </div>
                        <div className='d-flex align-items-center gap-3 mt-5'>
                          <Field
                            type='radio'
                            name='promoCluster'
                            id='promoCluster'
                            className='form-check-input'
                            value='9'
                            onChange={() => {
                              setFieldValue('promoCluster', '9')
                              setFieldValue('promoGroup', '10')
                              setFieldValue('campaignType', '3')
                              setFieldValue('priceCluster', [])
                              setFieldValue('fixedValue', '100')
                              setFieldValue('amountToBeSpent', '0')
                              setFieldValue('pointsToBeEarned', '0')
                              selectedGiveAwayProductSet([])
                            }}
                          />
                          <div className='fs-6'>
                            {intl.formatMessage({ id: 'CAMPAIGN.TYPE.BIRTHDAY' })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='card mt-10'>
                  <div className='card-header'>
                    <div className='card-title d-flex flex-column'>
                      <div className='d-flex align-items-center position-relative my-1 mt-5 fs-2 fw-bold'>
                        {intl.formatMessage({ id: 'CAMPAIGN.EARNING_TYPE' })}&nbsp;
                        <span className='fs-2 text-danger'> *</span>
                      </div>
                      {values.promoCluster === '1' && (
                        <p className='fs-6 text-muted'>
                          {intl.formatMessage({ id: 'CAMPAIGN.EARNING_TYPE.DISCOUNT' })}
                        </p>
                      )}

                      {values.promoCluster === '2' && (
                        <p className='fs-6 text-muted'>
                          {intl.formatMessage({ id: 'CAMPAIGN.EARNING_TYPE.POINT' })}
                        </p>
                      )}

                      {values.promoCluster === '9' && (
                        <p className='fs-6 text-muted'>
                          {intl.formatMessage({ id: 'CAMPAIGN.EARNING_TYPE.BIRTDAY' })}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className={`card-body mt-5 pt-2 pb-2 ${disabled ? 'card-disabled' : ''}`}>
                    <div>
                      {/* {sectionRenderCampaign(Field, values, setFieldValue)} */}
                      <div style={{ marginTop: '-20px' }}>
                        {sectionRender(Field, values, setFieldValue, disabled)}
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className='card mt-10'>
                  {values.promoCluster !== '9' && (
                    <>
                      <div className='card-header'>
                        <div className='card-title d-flex flex-column'>
                          <div className='d-flex align-items-center position-relative my-1 fs-2 fw-bold'>
                            {intl.formatMessage({id: 'CAMPAIGN.PRODUCTS.SELECTED'})}
                          </div>
                          <p className='fs-6 text-muted'>
                            {values.promoCluster === '2' ? (
                              <>
                                {intl.formatMessage({id: 'CAMPAIGN.PRODUCTS.SELECTED.DESC.POINT'})}
                              </>
                            ) : (
                              <>{intl.formatMessage({id: 'CAMPAIGN.PRODUCTS.SELECTED.DESC'})}</>
                            )}
                          </p>
                        </div>
                      </div>
                      <CampaignProducts
                        Field={Field}
                        setSection={setSection}
                        values={values}
                        setFieldValue={setFieldValue}
                      />
                    </>
                    // </div>
                  )}
                </div> */}

                {values.promoGroup === '6' || values.promoGroup === '15' ? (
                  <div className='card mt-10'>
                    <div className='card-header'>
                      <div className='card-title d-flex flex-column'>
                        <div className='d-flex align-items-center position-relative my-1 fs-2 fw-bold'>
                          {intl.formatMessage({ id: 'CAMPAIGN.GIVE_AWAY_PRODUCTS' })}
                        </div>
                        <p className='fs-6 text-muted'>
                          {intl.formatMessage({ id: 'CAMPAIGN.GIVE_AWAY_PRODUCTS.DESC' })}
                        </p>
                      </div>
                    </div>
                    <CampaignProductsGiveAway
                      Field={Field}
                      values={values}
                      setFieldValue={setFieldValue}
                      setSection={setSection}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </Form>
        </div>
      )}

      {section === 2 && (
        <SelectProducts
          allProducts={vipCampaignProductListAll.data}
          paging={vipCampaignProductListAll.paging}
          pagingSet={(paging: any) => {
            vipCampaignProductListAllSet({
              ...vipCampaignProductListAll,
              paging,
            })
          }}
          handleBack={() => setSection(1)}
          setSection={setSection}
        />
      )}

      {section === 3 && (
        <SelectGiftProducts
          allProducts={vipCampaignProductListAll.data}
          paging={vipCampaignProductListAll.paging}
          pagingSet={(paging: any) => {
            vipCampaignProductListAllSet({
              ...vipCampaignProductListAll,
              paging,
            })
          }}
          handleBack={() => setSection(1)}
          setSection={setSection}
          selectedProducts={values.priceCluster?.[0]?.productList || []}
          setSelectedProducts={(productList) => {
            const priceCluster = values.priceCluster.map((item: any) => ({
              ...item,
              productList,
            }))

            setFieldValue('priceCluster', priceCluster)
          }}
        />
      )}
    </>
  )
}

export default CampaignEdit
